export default __webpack_public_path__ + "static/media/voice-assistance.e2d7a41e.png";